$(document).ready(function () {
    $(".tabHeadingContainer").click(function () {
        $(".tabHeadingContainer").removeClass("activeTab");
        $(this).addClass("activeTab");
        var dataImgId = $(this).attr("data-id");
        $(".tabHeadingImgContainer").hide();
        $(dataImgId).fadeIn(500);
    });
    if ($('.mobile-menu__submenu').length > 0) {
        $('.mobile-menu__submenu .mega-menu').prepend('<span class="closeMegaBtn">→</span>');
    }

    if ($(window).width() > 798) {
        if ($(".hasAnnouncementBar").length > 0) {
            $(window).scroll(function () {
                var scrollPosition = $(this).scrollTop();
                if (scrollPosition >= 100) {
                    $('body').addClass('stickyMobileHeader');
                    console.log("AddinBar");
                } else {
                    $('body').removeClass('stickyMobileHeader');
                    console.log("RemovenBar")
                }
            });
        }
        else {
            $('body').addClass('stickyMobileHeader');
        }
    }
    $("button.hamMenuBtn").click(function () {
        $("html").toggleClass("hideScroll");
        $("body").toggleClass("mobileMenuIsOpen");
        $(".mobile-header").toggleClass("isOpen");
    });

    $(".submenu__label span.close-dropdown").click(function () {
        $("body").addClass("disabledMainMenuItems");
    });
    $('.mobile-menu__submenu .mega-menu .closeMegaBtn').on('click', function () {
        $('.submenu__input').prop('checked', false);
        $("body").removeClass("disabledMainMenuItems");
    });



});

